import styled from 'styled-components';

interface RadioCircleProps {
  isSelected: boolean;
}

export const RadioCircle = ({ isSelected }: RadioCircleProps) => {
  return <Circle>{isSelected && <Dot />}</Circle>;
};

const Circle = styled.div`
  width: 16px;
  height: 16px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 2px;
  gap: 8px;

  border-radius: 50px;
  border: 1px solid var(--Light-Scheme-Monochrome-grey30, #d5d5e3);
  background: #fff;
`;

const Dot = styled.div`
  width: 10px;
  height: 10px;
  flex-shrink: 0;

  border-radius: 50px;
  background: var(--Light-Scheme-Color-primary-blue, #445eff);
`;
